import React, { FC } from 'react';
import { List } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { Employee } from '~/types';
import EmployeeCard from './EmployeeCard';
import { useDeepEffect, usePath, usePermissions } from '~/hooks';
import theme from '~/theme';

interface Props {
  data: Employee[] | undefined;
  total: number;
  loading: boolean;
}

const CardsList: FC<Props> = (props) => {
  const { data, loading, total } = props;
  const { pagination, changePath } = usePath();

  let column = 4;
  const isDesktop = useMediaQuery({ maxWidth: 1790 });
  const isLaptop = useMediaQuery({ maxWidth: 1440 });
  const isTablet = useMediaQuery({ maxWidth: 1000 });
  if (isDesktop) column = 3;
  if (isLaptop) column = 2;
  if (isTablet) column = 1;

  let gutter = 24;
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.sm });
  if (isMobile) {
    gutter = 16;
  }

  const pageSize = column * 3;
  useDeepEffect(() => {
    changePath({ page: 1, perPage: pageSize });
  }, [pageSize]);

  const hasAccessView = usePermissions('business.employee.view');

  return (
    <List
      grid={{ gutter, column }}
      dataSource={data}
      pagination={{
        pageSize,
        ...pagination,
        total,
      }}
      renderItem={(item) => (
        <List.Item key={item.id}>
          <EmployeeCard data={item} loading={loading} hasAccessView={hasAccessView} />
        </List.Item>
      )}
    />
  );
};

export default CardsList;
